import { Card, Spin } from "antd";
import React, { useEffect, useState } from "react";
import "../index.css";

import { getMissedChatsCount } from "../APIs/firebaseDashboardApis";

const MissedChats = ({ propertyIds, dateRange, rangeLabel }) => {
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (propertyIds?.length > 0 && dateRange.length > 0) {
      const fetchMissedChatCount = async () => {
        setLoading(true);
        const response = await getMissedChatsCount(propertyIds, dateRange)
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setLoading(false);
          });
        setCount(response);
      };
      fetchMissedChatCount();
    }
  }, [propertyIds, dateRange]);

  return (
    <Spin spinning={loading}>
      <Card
        className="dashboard_card"
        title={
          <>
            <i className="fa-regular fa-comment"></i>
            <span className="card_title">Missed Chats</span>
          </>
        }
      >
        <div className="card-stats-body">
          <p className="stats-body-number-heading">{rangeLabel}</p>
          <p className="stats-body-number">{count}</p>
        </div>
      </Card>
    </Spin>
  );
};

export default React.memo(MissedChats);
